/**
 * Concierge-specific constants and settings
 */
import { getThemeVariableValue } from '#app/containers/ThemeLoader';

export const SUPPORT_EMAIL = getThemeVariableValue('support-email');
export const COMPLIANCE_EMAIL = getThemeVariableValue('compliance-email');
